import React, { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReactReader } from "react-reader";

import "../../Styles/BookRead.css";
import { Transaction_Book } from "../../Connections/Transaction";
import { useEffect } from "react";

const ReadBook = () => {
  const navigator = useNavigate();
  const params = useParams();
  const renditionRef = useRef(null);
  const tocRef = useRef(null);
  // =======================================================

  const [location, setLocation] = useState("epubcfi(/6/2!/4/4/2/2/1:0)");
  const [page, setPage] = useState("");

  const [propgressWidth, setProgressWidth] = useState(0);
  const [book, setBook] = useState({});
  const [Bookname, setBookname] = useState();

  // =======================================================
  useEffect(() => {
    Transaction_Book.GetOneBooks(params.id).then((res) => {
      if (res[0]) {
        setBookname(res[2].data.preTitle);
      }
    });
  }, []);
  const locationChanged = (epubcifi) => {
    setLocation(epubcifi);
    if (document.body.clientWidth < 900) {
      let iframedoc =
        document.getElementsByTagName("iframe")[0].contentDocument;
      iframedoc.body.style.direction = "ltr";
      iframedoc.body.style.textAlign = "right";
    }

    let page = epubcifi.split("/")[2];
    let number = Number(page.replace("!", ""));

    if (renditionRef.current && tocRef.current) {
      if (number == renditionRef.current.book.locations.spine.length * 2) {
        const postedData = {
          page: Number(location.split("/")[2].split("!")[0]) || 0,
          pageCount:
            renditionRef.current?.book?.locations.spine.length * 2 || 0,
          bookId: params.id,
        };

        Transaction_Book.AddBookRead(postedData).catch((err) =>
          console.log(err)
        );
      }
      setProgressWidth(
        (Number(page.split("!")[0]) /
          (renditionRef.current.book.locations.spine.length * 2)) *
          100
      );

      setPage(
        `${number}  از  ${renditionRef.current.book.locations.spine.length * 2}`
      );
    }
  };

  const handleBackToBookPage = () => {
    navigator(
      params.id < 10
        ? `/book/SE0${params.id}/${Bookname}`
        : `/book/SE${params.id}/${Bookname}`,
      {
        state: { reGetBook: true, prevPath: "bookRead" },
      }
    );
  };

  const reactReaderStyles = {
    container: {
      overflow: "hidden",
      height: "100%",
    },
    readerArea: {
      position: "relative",
      zIndex: 1,
      height: "100%",
      width: "100%",
      backgroundColor: "#fff",
      transition: "all .3s ease",
    },
    containerExpanded: {
      transform: "translateX(256px)",
    },
    titleArea: {
      position: "absolute",
      top: 20,
      left: 50,
      right: 50,
      textAlign: "center",
      color: "#999",
    },
    reader: {
      position: "absolute",
      top: 50,
      left: 50,
      bottom: 20,
      right: 50,
    },
    swipeWrapper: {
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 200,
    },
    prev: {
      left: 1,
    },
    next: {
      right: 1,
    },
    arrow: {
      display: "none",
      background: "none",
      position: "fixed",
      top: "92.5%",
      marginTop: 0,
      fontSize: 25,
      padding: "10px",
      color: "black",
      width: "4%",
      fontFamily: "arial, sans-serif",
      cursor: "pointer",
      userSelect: "none",
      appearance: "none",
      fontWeight: "normal",
      right: "47%",
      left: "54%",
      // opacity: 0,
    },
    arrowHover: {
      color: "#777",
    },
    tocBackground: {
      position: "absolute",
      left: 256,
      top: 0,
      bottom: 0,
      right: 0,
      zIndex: 1,
    },
    tocArea: {
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      zIndex: 0,
      width: 256,
      overflowY: "auto",
      WebkitOverflowScrolling: "touch",
      background: "#f2f2f2",
      padding: "10px 0",
    },
    tocAreaButton: {
      userSelect: "none",
      appearance: "none",
      background: "red",
      border: "none",
      display: "block",
      fontFamily: "sans-serif",
      width: "100%",
      fontSize: ".9em",
      textAlign: "left",
      padding: ".9em 1em",
      borderBottom: "1px solid #ddd",
      color: "#aaa",
      boxSizing: "border-box",
      outline: "none",
      cursor: "pointer",
    },
    tocButton: {
      background: "none",
      border: "none",
      width: 32,
      height: 32,
      position: "absolute",
      top: 10,
      left: 10,
      borderRadius: 2,
      outline: "none",
      cursor: "pointer",
    },
    tocButtonExpanded: {
      background: "#f2f2f2",
    },
    tocButtonBar: {
      position: "absolute",
      width: "60%",
      background: "#ccc",
      height: 2,
      left: "50%",
      margin: "-1px -30%",
      top: "50%",
      transition: "all .5s ease",
    },
    tocButtonBarTop: {
      top: "35%",
    },
    tocButtonBottom: {
      top: "66%",
    },
    loadingView: {
      position: "absolute",
      top: "50%",
      left: "10%",
      right: "10%",
      color: "#ccc",
      textAlign: "center",
      margintop: "-.5em",
    },
  };

  // =======================================================

  useEffect(() => {
    Transaction_Book.GetOneBooks(params.id)
      .then((res) => {
        if (res[0]) {
          setBook(res[2].data);
        } else {
          navigator(`/book/${book.id}`);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // =======================================================

  return (
    <div style={{ height: "100vh", position: "relative" }}>
      <div
        style={{
          width: "100%",
          position: "absolute",
          top: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "1060px",
            padding: "15px",
            zIndex: "2",
            background: "#FFFFFF",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <div style={{ cursor: "pointer" }} onClick={handleBackToBookPage}>
            <svg
              width="8"
              height="18"
              viewBox="0 0 12 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.95054 23.6665C2.19953 23.6673 2.44555 23.6124 2.67052 23.5057C2.89548 23.3989 3.09368 23.2432 3.25054 23.0498L11.3005 13.0498C11.5457 12.7516 11.6797 12.3775 11.6797 11.9915C11.6797 11.6054 11.5457 11.2314 11.3005 10.9331L2.96721 0.933142C2.68431 0.592781 2.27779 0.37874 1.83708 0.338107C1.39637 0.297474 0.957569 0.433578 0.617208 0.716475C0.276847 0.999373 0.0628071 1.40589 0.0221739 1.8466C-0.0184593 2.28731 0.117643 2.72611 0.400541 3.06647L7.85054 11.9998L0.650542 20.9331C0.446737 21.1778 0.317275 21.4757 0.277475 21.7916C0.237677 22.1075 0.289205 22.4282 0.425964 22.7158C0.562724 23.0033 0.778991 23.2457 1.04917 23.4142C1.31936 23.5826 1.63215 23.6702 1.95054 23.6665Z"
                fill="#020D1B"
              />
            </svg>
          </div>

          <div style={{ cursor: "pointer" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M33.7496 20.9503V19.0378L36.1496 16.9378C36.592 16.5478 36.8823 16.014 36.9692 15.4308C37.0561 14.8475 36.9341 14.2522 36.6246 13.7503L33.6746 8.75026C33.4554 8.37059 33.1402 8.05524 32.7606 7.83584C32.3811 7.61644 31.9505 7.50071 31.5121 7.50026C31.2404 7.49818 30.9702 7.5404 30.7121 7.62526L27.6746 8.65026C27.1502 8.30177 26.6031 7.98858 26.0371 7.71276L25.3996 4.56276C25.2853 3.98727 24.9722 3.47031 24.5151 3.10239C24.0581 2.73447 23.4862 2.53902 22.8996 2.55026H17.0496C16.463 2.53902 15.8911 2.73447 15.434 3.10239C14.977 3.47031 14.6639 3.98727 14.5496 4.56276L13.9121 7.71276C13.342 7.98851 12.7908 8.3017 12.2621 8.65026L9.28708 7.57526C9.0262 7.50729 8.75605 7.48197 8.48708 7.50026C8.04868 7.50071 7.6181 7.61644 7.23854 7.83584C6.85898 8.05524 6.54379 8.37059 6.32458 8.75026L3.37458 13.7503C3.08282 14.2515 2.9744 14.8386 3.06789 15.411C3.16139 15.9834 3.45099 16.5054 3.88708 16.8878L6.24958 19.0503V20.9628L3.88708 23.0628C3.43867 23.4478 3.14115 23.9792 3.04733 24.5627C2.95351 25.1462 3.06945 25.7441 3.37458 26.2503L6.32458 31.2503C6.54379 31.6299 6.85898 31.9453 7.23854 32.1647C7.6181 32.3841 8.04868 32.4998 8.48708 32.5003C8.75877 32.5023 9.02898 32.4601 9.28708 32.3753L12.3246 31.3503C12.849 31.6988 13.3961 32.0119 13.9621 32.2878L14.5996 35.4378C14.7139 36.0133 15.027 36.5302 15.484 36.8981C15.9411 37.2661 16.513 37.4615 17.0996 37.4503H22.9996C23.5862 37.4615 24.1581 37.2661 24.6151 36.8981C25.0722 36.5302 25.3853 36.0133 25.4996 35.4378L26.1371 32.2878C26.7072 32.012 27.2584 31.6988 27.7871 31.3503L30.8121 32.3753C31.0702 32.4601 31.3404 32.5023 31.6121 32.5003C32.0505 32.4998 32.4811 32.3841 32.8606 32.1647C33.2402 31.9453 33.5554 31.6299 33.7746 31.2503L36.6246 26.2503C36.9163 25.749 37.0248 25.1619 36.9313 24.5896C36.8378 24.0172 36.5482 23.4951 36.1121 23.1128L33.7496 20.9503ZM31.5121 30.0003L27.2246 28.5503C26.2209 29.4004 25.0738 30.0649 23.8371 30.5128L22.9496 35.0003H17.0496L16.1621 30.5628C14.9351 30.1022 13.7942 29.4388 12.7871 28.6003L8.48708 30.0003L5.53708 25.0003L8.93708 22.0003C8.70595 20.7063 8.70595 19.3817 8.93708 18.0878L5.53708 15.0003L8.48708 10.0003L12.7746 11.4503C13.7783 10.6001 14.9253 9.93558 16.1621 9.48777L17.0496 5.00026H22.9496L23.8371 9.43777C25.0641 9.89829 26.2049 10.5617 27.2121 11.4003L31.5121 10.0003L34.4621 15.0003L31.0621 18.0003C31.2932 19.2942 31.2932 20.6188 31.0621 21.9128L34.4621 25.0003L31.5121 30.0003Z"
                fill="#020D1B"
              />
              <path
                d="M20 27.5C18.5166 27.5 17.0666 27.0601 15.8332 26.236C14.5999 25.4119 13.6386 24.2406 13.0709 22.8701C12.5032 21.4997 12.3547 19.9917 12.6441 18.5368C12.9335 17.082 13.6478 15.7456 14.6967 14.6967C15.7456 13.6478 17.082 12.9335 18.5368 12.6441C19.9917 12.3547 21.4997 12.5032 22.8701 13.0709C24.2406 13.6386 25.4119 14.5999 26.236 15.8332C27.0601 17.0666 27.5 18.5166 27.5 20C27.51 20.9877 27.3229 21.9675 26.9495 22.882C26.5762 23.7964 26.0241 24.6272 25.3257 25.3257C24.6272 26.0241 23.7964 26.5762 22.882 26.9495C21.9675 27.3229 20.9877 27.51 20 27.5ZM20 15C19.3392 14.9846 18.6821 15.1034 18.0685 15.3492C17.4549 15.5951 16.8976 15.9628 16.4302 16.4302C15.9628 16.8976 15.5951 17.4549 15.3492 18.0685C15.1034 18.6821 14.9846 19.3392 15 20C14.9846 20.6608 15.1034 21.3179 15.3492 21.9315C15.5951 22.5451 15.9628 23.1024 16.4302 23.5698C16.8976 24.0372 17.4549 24.4049 18.0685 24.6508C18.6821 24.8966 19.3392 25.0154 20 25C20.6608 25.0154 21.3179 24.8966 21.9315 24.6508C22.5451 24.4049 23.1024 24.0372 23.5698 23.5698C24.0372 23.1024 24.4049 22.5451 24.6508 21.9315C24.8966 21.3179 25.0154 20.6608 25 20C25.0154 19.3392 24.8966 18.6821 24.6508 18.0685C24.4049 17.4549 24.0372 16.8976 23.5698 16.4302C23.1024 15.9628 22.5451 15.5951 21.9315 15.3492C21.3179 15.1034 20.6608 14.9846 20 15Z"
                fill="#020D1B"
              />
            </svg>
          </div>

          <div style={{ cursor: "pointer" }}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.0902 27.3252L33.9727 32.2052C34.2004 32.441 34.3264 32.7567 34.3235 33.0845C34.3207 33.4122 34.1892 33.7257 33.9575 33.9575C33.7257 34.1892 33.4122 34.3207 33.0845 34.3235C32.7567 34.3264 32.441 34.2004 32.2052 33.9727L27.3227 29.0902C24.1321 31.8238 20.0067 33.2154 15.8122 32.9729C11.6177 32.7305 7.6802 30.8728 4.82583 27.7898C1.97146 24.7067 0.422153 20.638 0.503013 16.4373C0.583874 12.2365 2.28861 8.23042 5.25952 5.25952C8.23042 2.28861 12.2365 0.583874 16.4373 0.503013C20.638 0.422153 24.7067 1.97146 27.7898 4.82583C30.8728 7.6802 32.7305 11.6177 32.9729 15.8122C33.2154 20.0067 31.8238 24.1321 29.0902 27.3227V27.3252ZM16.7502 30.5002C20.3969 30.5002 23.8943 29.0515 26.4729 26.4729C29.0515 23.8943 30.5002 20.3969 30.5002 16.7502C30.5002 13.1035 29.0515 9.60611 26.4729 7.02748C23.8943 4.44886 20.3969 3.0002 16.7502 3.0002C13.1035 3.0002 9.60611 4.44886 7.02748 7.02748C4.44886 9.60611 3.0002 13.1035 3.0002 16.7502C3.0002 20.3969 4.44886 23.8943 7.02748 26.4729C9.60611 29.0515 13.1035 30.5002 16.7502 30.5002Z"
                fill="#020D1B"
              />
            </svg>
          </div>

          <div style={{ cursor: "pointer" }}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 34 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.333984 1.99134C0.333984 1.07467 1.07732 0.333008 1.99232 0.333008H15.3423C15.7821 0.333008 16.2039 0.507724 16.5149 0.818722C16.8259 1.12972 17.0007 1.55152 17.0007 1.99134C17.0007 2.43116 16.8259 2.85296 16.5149 3.16396C16.2039 3.47496 15.7821 3.64967 15.3423 3.64967H1.99232C1.5525 3.64967 1.1307 3.47496 0.819699 3.16396C0.508701 2.85296 0.333984 2.43116 0.333984 1.99134V1.99134ZM0.333984 11.9997C0.333984 11.083 1.07732 10.3413 1.99232 10.3413H32.009C32.4488 10.3413 32.8706 10.5161 33.1816 10.8271C33.4926 11.1381 33.6673 11.5599 33.6673 11.9997C33.6673 12.4395 33.4926 12.8613 33.1816 13.1723C32.8706 13.4833 32.4488 13.658 32.009 13.658H1.99232C1.5525 13.658 1.1307 13.4833 0.819699 13.1723C0.508701 12.8613 0.333984 12.4395 0.333984 11.9997V11.9997ZM1.99232 20.3497C1.5525 20.3497 1.1307 20.5244 0.819699 20.8354C0.508701 21.1464 0.333984 21.5682 0.333984 22.008C0.333984 22.4478 0.508701 22.8696 0.819699 23.1806C1.1307 23.4916 1.5525 23.6663 1.99232 23.6663H22.009C22.4488 23.6663 22.8706 23.4916 23.1816 23.1806C23.4926 22.8696 23.6673 22.4478 23.6673 22.008C23.6673 21.5682 23.4926 21.1464 23.1816 20.8354C22.8706 20.5244 22.4488 20.3497 22.009 20.3497H1.99232Z"
                fill="#020D1B"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        style={{
          height: "80vh",
          direction: "ltr",
          fontFamily: "kalameh",
        }}
      >
        <ReactReader
          showToc={false}
          swipeable={true}
          location={location}
          locationChanged={locationChanged}
          url={book.epub}
          styles={reactReaderStyles}
          getRendition={(rendition) => {
            renditionRef.current = rendition;
            renditionRef.current.themes.register("custom", {
              "*": {
                "font-family": `kalameh`,
              },
              body: {
                direction: "rtl",
              },
              ".contenth1": {
                "font-family": `kalameh`,
                "font-size": "18px",
                "font-weight": "700",
              },
              ".contenth2": {
                "font-family": `kalameh`,
                "font-size": "16px",
                "font-weight": "700",
              },
              ".contenth3": {
                "font-family": `kalameh`,
                "font-size": "14px",
                "font-weight": "700",
              },
              ".contenth": {
                "font-family": `kalameh`,
              },
            });
            renditionRef.current.themes.select("custom");
          }}
          tocChanged={(toc) => (tocRef.current = toc)}
        />
      </div>
      <div
        style={{
          width: "100%",
          position: "absolute",
          bottom: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="BookRead_progressBar-wrapper">
          <div
            className="BookRead_progressBar"
            style={{ width: `${propgressWidth}%` }}
          ></div>
        </div>
        <div
          style={{
            width: "100%",
            maxWidth: "250px",
            height: "50px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{ margin: "0 20px", cursor: "pointer" }}
            onClick={() => renditionRef.current.prev()}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.75 16.5L21.75 13.5L18.75 10.5"
                stroke="#020D1B"
                strokeWidth="1.1875"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21 13.5H7.21875C4.46438 13.5 2.25 11.1877 2.25 8.4375V7.5"
                stroke="#020D1B"
                strokeWidth="1.1875"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div style={{ color: "black" }}>{page}</div>
          <div
            style={{ margin: "0 20px", cursor: "pointer" }}
            onClick={() => renditionRef.current.next()}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.25 16.5L2.25 13.5L5.25 10.5"
                stroke="#020D1B"
                strokeWidth="1.1875"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3 13.5H16.7812C19.5356 13.5 21.75 11.1877 21.75 8.4375V7.5"
                stroke="#020D1B"
                strokeWidth="1.1875"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReadBook;
